<template>
  <div>
    <div v-if="yxfile">
      <el-link :type="status==0?'info':(status==1?'primary':'error')">{{yxfile.name}}</el-link>
    </div>
    <el-upload class="upload-demo" action="https://jsonplaceholder.typicode.com/posts/" :on-preview="handlePreview"
      :on-remove="handleRemove" :multiple="false" :on-change="handleChange" :auto-upload="false" :file-list="fileList"
      :show-file-list="false">
      <el-button slot="trigger" size="small" type="primary">选取视频</el-button>
      <el-button style="margin-left: 10px;" size="small" type="success" @click="submitUpload">上传到服务器</el-button>
      <div slot="tip" class="el-upload__tip">支持.mp4格式，推荐H264编码，大小不超过2G，仅可上传一个视频</div>
    </el-upload>
    <div v-if="isprogress">
      <el-progress :text-inside="true" :stroke-width="26" :percentage="progress"></el-progress>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'uploadAl',
    props: ['kcfile'],
    data() {
      return {
        fileList: [],
        yxfile: null,
        uploader: null,
        isprogress: false,
        progress: 0,
        status: 0,
        videoXstime: '00:00:00'
      }
    },
    methods: {
      // 阿里云上传
      submitUpload: function() {
        if (!this.yxfile) {
          return;
        }
        var file = this.yxfile['raw'];
        var uploadInfo = new Object;
        uploadInfo.file = file;
        var videoid = sessionStorage.getItem("videoid");
        var that = this;
        var uploader = new AliyunUpload.Vod({
          userId: "1362262321513414", //必填
          region: "cn-beijing", //上传到视频点播的地域，默认值为'cn-shanghai'，
          partSize: 1048576, //分片大小默认1 MB，不能小于100 KB（100*1024）
          parallel: 5, //并行上传分片个数，默认5
          retryCount: 3, //网络原因失败时，重新上传次数，默认为3
          retryDuration: 2, //网络原因失败时，重新上传间隔时间，默认为2秒
          //开始上传
          'onUploadstarted': function(uploadInfo) {
            // 如果是 UploadAuth 上传方式, 需要调用 uploader.setUploadAuthAndAddress 方法
            // 如果是 UploadAuth 上传方式, 需要根据 uploadInfo.videoId是否有值，调用点播的不同接口获取uploadauth和uploadAddress
            // 如果 uploadInfo.videoId 有值，调用刷新视频上传凭证接口，否则调用创建视频上传凭证接口
            // 注意: 这里是测试 demo 所以直接调用了获取 UploadAuth 的测试接口, 用户在使用时需要判断 uploadInfo.videoId 存在与否从而调用 openApi
            // 如果 uploadInfo.videoId 存在, 调用 刷新视频上传凭证接口(https://help.aliyun.com/document_detail/55408.html)
            // 如果 uploadInfo.videoId 不存在,调用 获取视频上传地址和凭证接口(https://help.aliyun.com/document_detail/55407.html)
            that.isprogress = true;
            if (!videoid) {
              that.$axios.get('/file/attachment/getuploadFileDB.htm?fileName=' + uploadInfo.file.name).then((
                updateRes) => {
                if (updateRes.data) {
                  var data = updateRes.data;
                  var videoid = data.videoid;
                  //放进缓存
                  sessionStorage.setItem("videoid", data.videoid);
                  sessionStorage.setItem('videoName', file.name);
                  that.$emit('changeKc', data.videoid, file.name, that.videoXstime);
                  var uploadaddress = data.uploadaddress
                  var uploadauth = data.uploadauth;
                  uploader.setUploadAuthAndAddress(uploadInfo, uploadauth, uploadaddress, videoid)
                }
              });
            } else {
              that.$axios.get('/file/attachment/getRefreshUpload.htm?id=' + videoid).then((updateRes) => {
                if (updateRes.data) {
                  var data = updateRes.data;
                  var videoid = data.videoid;
                  var uploadaddress = data.uploadaddress;
                  var uploadauth = data.uploadauth;
                  //放进缓存
                  sessionStorage.setItem("videoid", data.videoid);
                  sessionStorage.setItem('videoName', file.name);
                  that.$emit('changeKc', data.videoid, file.name, that.videoXstime);
                  uploader.setUploadAuthAndAddress(uploadInfo, uploadauth, uploadaddress, videoid)
                }
              });
            }

          },
          //文件上传成功
          'onUploadSucceed': function(uploadInfo) {
            var name = file.name;
            that.$message({
              showClose: true,
              message: '文件上传成功！',
              type: 'success'
            });
            that.status = 1;
          },
          //文件上传失败
          'onUploadFailed': function(uploadInfo, code, message) {
            that.$message({
              showClose: true,
              message: '文件上传失败！',
              type: 'error'
            });
            that.status = 2;
          },
          //文件上传进度，单位：字节
          'onUploadProgress': function(uploadInfo, totalSize, loadedPercent) {
            console.log(loadedPercent)
            that.progress = Math.ceil(loadedPercent * 100);
          },
          //上传凭证或STS token超时
          'onUploadTokenExpired': function(uploadInfo) {
            that.$axios.get('/file/attachment/getRefreshUpload.htm?id=' + videoid).then((updateRes) => {
              if (updateRes.data.stat == '1') {
                var uploadauth = data.uploadauth;
                uploader.resumeUploadWithAuth(uploadauth)
              }
            });
          },
          //全部文件上传结束
          'onUploadEnd': function(uploadInfo) {
            that.isprogress = false;
            that.progress = 0;
          }
        });
        this.uploader = uploader;
        var userData = '{"Vod":{}}'
        uploader.addFile(file, null, null, null, userData);
        uploader.startUpload();
      },
      handlePreview: function(file) {
        console.log('handlePreview')
        console.log(file, 'handlePreview');
      },
      handleRemove: function(file) {
        this.fileList = [];
        this.yxfile = null;
      },
      handleChange: function(file) {
        this.fileList = [file];
        this.yxfile = file;
        this.status = 0;
        var that = this;
        // 获取视频时长
        const url = URL.createObjectURL(file.raw);
        const audioElement = new Audio(url);
        let videoSeconds;
        audioElement.addEventListener('loadedmetadata', (_event) => {
          videoSeconds = Math.floor(audioElement.duration);
          var miaoshi = Math.floor(videoSeconds % 60); //获取秒数
          var fenzhong = Math.floor(videoSeconds / 60); //获取分钟
          var xiaoshi = 0;
          if (fenzhong > 59) { //超过了1小时
            xiaoshi = Math.floor(fenzhong / 60);
            fenzhong = Math.floor(fenzhong % 60);
          };
          var shichang = (xiaoshi > 9 ? xiaoshi : '0' + xiaoshi) + ':';
          shichang += (fenzhong > 9 ? fenzhong : '0' + fenzhong) + ':';
          shichang += miaoshi > 9 ? miaoshi : '0' + miaoshi;
          // 获取视频的时长
          // sessionStorage.setItem('videoXstime', shichang);
          that.videoXstime = shichang;
          that.$emit('changeKc','', '', shichang);
        });
      }
    },
    watch: {
      kcfile: { //深度监听，可监听到对象、数组的变化
        handler(val, oldVal) {
          this.fileList = [val];
          this.yxfile = val;
          this.status = 1;
        },
        deep: true //true 深度监听
      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/common/UploadAl.vue